import { render, staticRenderFns } from "./BlockType6.vue?vue&type=template&id=53443431&scoped=true"
import script from "./BlockType6.vue?vue&type=script&lang=ts"
export * from "./BlockType6.vue?vue&type=script&lang=ts"
import style0 from "./BlockType6.vue?vue&type=style&index=0&id=53443431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53443431",
  null
  
)

export default component.exports